import { stats } from '@fiverr-private/obs';

export const PACKAGE_NAME = `portfolio`;

/**
 * The current service prefixed stats instance.
 */
export const metric = stats.prefix(`packages.${PACKAGE_NAME}`);
